const mockData = {
  heroImage: 'https://images.pexels.com/photos/262047/pexels-photo-262047.jpeg?auto=compress&cs=tinysrgb&w=1920',
  
  aboutText: 'Con más de cinco décadas de experiencia, en IL POSTO nos especializamos en crear mobiliario que define ambientes gastronómicos memorables. Nuestro compromiso con la excelencia nos lleva a diseñar cada pieza pensando en la durabilidad, el confort y la estética que tu establecimiento merece.',
  
  aboutImage: '/assets/showroom-ilposto-rotated.jpg',
  
  productCategories: [
    {
      name: 'Sillas',
      image: '/assets/sillas-producto.jpg'
    },
    {
      name: 'Taburetes',
      image: '/assets/taburetes-producto.jpg'
    },
    {
      name: 'Mesas',
      image: '/assets/mesas-producto.jpg'
    },
    {
      name: 'Sillones',
      image: '/assets/sillones-producto-rotated.jpg'
    }
  ],
  
  clientGallery: [
    {
      name: 'Negroni',
      location: 'Puerto Madero',
      image: '/assets/negroni-puerto-madero.jpg'
    },
    {
      name: 'Confitería La Ideal',
      location: 'CABA',
      image: '/assets/confiteria-la-ideal.jpg'
    },
    {
      name: 'Hard Rock',
      location: 'Ushuaia',
      image: '/assets/hard-rock-ushuaia.jpg'
    },
    {
      name: 'La Panera Rosa',
      location: '',
      image: '/assets/la-panera-rosa.jpg'
    },
    {
      name: 'Don Julio',
      location: 'Palermo',
      image: '/assets/don-julio-palermo.jpg'
    },
    {
      name: 'El Club de la Milanesa',
      location: '',
      image: '/assets/el-club-de-la-milanesa.jpg'
    }
  ],
  
  contact: {
    address: 'Mercedes 2795, San Andrés, Buenos Aires',
    phone: '011 4755-1591',
    email: 'ilposto11@hotmail.com',
    whatsapp: '5491147551591',
    website: 'www.il-posto.com.ar'
  }
};

export default mockData;